import { SortGet } from "../../../../../_ovlclient/src/global/globalapi"
import { ListDefinition } from "../../../../../_ovlclient/src/library/table/table"

let submittedUrlParams = {
  groupName: "",
  problemTypeId: -1,
  urlHandled: false,
}
let NewService = {
  contact: {
    cardGroup: "",
    id: "",
    email: "",
    mobilePhone: "",
    emailC: "",
    mobilePhoneC: "",
    firstNameC: "",
    lastNameC: "",
  },

  objectLocationParams: {
    Street: "ovlinitialvalue",
    ZipCode: "ovlinitialvalue",
    City: "ovlinitialvalue",
    Nr: "ovlinitialvalue",
    NoResultsLink: "",
    Adjusted: false,
    RunNr: 0,
    TooFar: false,
    MaxRange: 9999,
  },
  equipment: {
    id: "",
  },

  selectedProblemType: 0,
  selectedSlot: "",
  promo: {
    visible: false,
    error: "",
  },
  slotFinder: {
    zipCode: 0,
    slots: <ListDefinition>{ data: {}, index: {}, lookupDef: {} },
    noSlotsFound: false,
  },
}

export type NewServiceProblemTypeData = {
  ProblemType: string
  ProblemDesc: string
  Duration: number
  MaxRange: number
  Group: string
}

let problemData: { [key: string]: NewServiceProblemTypeData } = {}

let SVL = {
  lookups: {
    problemType: { data: problemData, lookupDef: {} },
    objectBuildingType: {},
    group: {},
    cardGroup: <ListDefinition>{
      lookupDef: {
        CardGroup: { type: "int" },
        CardGroupDesc: {
          type: "text",
          translationKey: "NewServiceRequesterType",
        },
      },
      data: {
        105: { CardGroup: 105, CardGroupDesc: "Mieter", CardType: "1" },
        111: { CardGroup: 111, CardGroupDesc: "Eigentümer", CardType: "1" },
        110: { CardGroup: 110, CardGroupDesc: "Hauswart", CardType: "2" },
        103: { CardGroup: 103, CardGroupDesc: "Sanitär", CardType: "2" },
        100: { CardGroup: 100, CardGroupDesc: "Verwaltung", CardType: "2" },
      },
      sortFn: (dataA, dataB) => SortGet(dataA.CardType, dataB.CardType),
    },
  },
  NewService,
}
let GEN = {
  submittedUrlParams,
}

export let global = { SVL, GEN }
